import { Router } from './Routes/Routes';
import { useRoutes } from 'react-router-dom';



function App() {
  const routing = useRoutes(Router)

  return (
    
    <div >
      {routing}
    </div>
  );
}

export default App;
